import { noticeError } from "../../../utils/newrelic/requests";
import {
  EnquiryRequest,
  EnquiryResponse,
} from "../components/TradeInModal/Grading/types";

export interface HttpResponse {
  status: number;
  body?: unknown;
  error?: unknown;
}

export type CreateEnquiryResponse = {
  status: number;
  error?: string;
  enquiry?: EnquiryResponse;
};

function handleError(error: Error): CreateEnquiryResponse {
  noticeError(`Notify API error: for create enquiry, error ${error}`);
  return { status: 400, error: "Create enquiry failed" };
}

export const createEnquiry = async (
  baseUrl: string,
  requestBody: EnquiryRequest,
  abortController: AbortController | null = null,
): Promise<CreateEnquiryResponse> => {
  const url = `${baseUrl}/enquiries`;
  return await fetch(url, {
    method: "POST",
    credentials: "omit",
    body: JSON.stringify(requestBody),
    headers: {
      "Content-Type": "application/json",
    },
    signal: abortController?.signal,
  })
    .then(async function (response: Response) {
      const { status } = await response;

      if (response.ok && (status >= 200 || status <= 299)) {
        return { status: status, enquiry: await response.json() };
      }
      return {
        status,
        error: "Create enquiry failed",
      };
    })
    .catch((e) => handleError(e));
};
